import './WhatToExpect.scss';

import { Container } from 'react-bootstrap';
import {
  faCheck,
  faCoins,
  faEnvelope,
  faShieldHalved,
  faUserCheck,
  faUserDoctor,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@myome/ui';

import { MarketingSectionIntro } from '@components/marketing/MarketingSectionIntro/MarketingSectionIntro';
import { MYOME_SUPPORT_EMAIL } from '@constants/constants';

const SUPPORT_MAILTO = `mailto:${MYOME_SUPPORT_EMAIL}`;

export const WhatToExpect = () => (
  <section className='fvt-expect marketing-section' aria-labelledby='fvt-expect-heading'>
    <Container fluid='xxl'>
      <MarketingSectionIntro
        variant='fvt'
        eyebrow='What to expect'
        heading='How this works for you, and for them'
        headingId='fvt-expect-heading'
      >
        <p>
          Family cascade genetic testing helps your relatives learn whether they carry the same <i>CASR</i> gene change
          (variant) to get the information they need. Everything is opt-in and private.
        </p>
      </MarketingSectionIntro>

      <div className='fvt-expect__grid gap-3 mt-4'>
        <article className='fvt-expect__card d-grid gap-3 align-items-start p-4'>
          <FontAwesomeIcon
            icon={faCheck}
            className='fvt-expect__card-icon d-inline-flex align-items-center justify-content-center'
            aria-hidden='true'
          />
          <div>
            <h3 className='mb-1'>You stay in control</h3>
            <p className='m-0'>
              You choose who we contact, and only the relatives you add receive an invitation. We never share your
              report with them.
            </p>
          </div>
        </article>

        <article className='fvt-expect__card d-grid gap-3 align-items-start p-4'>
          <FontAwesomeIcon
            icon={faCoins}
            className='fvt-expect__card-icon d-inline-flex align-items-center justify-content-center'
            aria-hidden='true'
          />
          <div>
            <h3 className='mb-1'>No-charge testing and genetic counseling</h3>
            <p className='m-0'>
              MyOme provides genetic testing for the specific <i>CASR</i> gene change found in your family, along with
              an appointment with a genetic counselor at no-charge.
            </p>
          </div>
        </article>

        <article className='fvt-expect__card d-grid gap-3 align-items-start p-4'>
          <FontAwesomeIcon
            icon={faUserCheck}
            className='fvt-expect__card-icon d-inline-flex align-items-center justify-content-center'
            aria-hidden='true'
          />
          <div>
            <h3 className='mb-1'>They decide separately</h3>
            <p className='m-0'>
              Each relative opts in on their own. They can decline or pause anytime, and you won&apos;t see their
              individual decisions.
            </p>
          </div>
        </article>

        <article className='fvt-expect__card d-grid gap-3 align-items-start p-4'>
          <FontAwesomeIcon
            icon={faShieldHalved}
            className='fvt-expect__card-icon d-inline-flex align-items-center justify-content-center'
            aria-hidden='true'
          />
          <div>
            <h3 className='mb-1'>Results stay private</h3>
            <p className='m-0'>
              Their results are their own. We don&apos;t share them back with you unless they ask us to.
            </p>
          </div>
        </article>
      </div>

      <div className='fvt-expect__counselor d-flex flex-wrap gap-3 align-items-center py-3 px-4 mt-4'>
        <span
          className='fvt-expect__counselor-avatar d-inline-flex flex-shrink-0 align-items-center justify-content-center'
          aria-hidden='true'
        >
          <FontAwesomeIcon icon={faUserDoctor} />
        </span>
        <div className='fvt-expect__counselor-text flex-grow-1'>
          <h3 className='mb-0'>Want to talk to someone first?</h3>
          <p className='m-0'>
            A genetic counselor is available to walk you through what your report means and what to tell your family.
          </p>
        </div>
        <div className='fvt-expect__counselor-actions d-flex flex-shrink-0 gap-2'>
          <Button
            href={SUPPORT_MAILTO}
            variant='secondary'
            className='fvt-expect__counselor-button'
            startIcon={<FontAwesomeIcon icon={faEnvelope} fontSize={16} />}
          >
            Contact support
          </Button>
        </div>
      </div>
    </Container>
  </section>
);
